// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBar_searchBox__2DUhU","icon":"SearchBar_icon__7QV-L"};